export default __webpack_public_path__ + "static/media/Content.e6ec0cac.svg";